import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NydusNetworkApiDataService } from '@rd/core/services/nydus-network-api-data/nydus-network-api-data.service';
import { EnrollmentModel } from '@rd/types/enrollment.model';
import { EnrollmentResponse } from '@rd/types/enrollment.response';
import { Enrollment } from '@rd/types/enrollment.type';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EnrollmentApiService {
  constructor(private nydusNetworkApiDataService: NydusNetworkApiDataService) {}

  getEnrollments(): Observable<Enrollment[]> {
    return this.nydusNetworkApiDataService
      .get<EnrollmentResponse>('enrollments')
      .pipe(
        map((enrollmentResponse) => {
          return this.transformEnrollmentsResponse(enrollmentResponse);
        }),
      );
  }

  getEnrollmentsWithJointAccounts(): Observable<Enrollment[]> {
    return this.nydusNetworkApiDataService
      .get<EnrollmentResponse>(
        'enrollments',
        new HttpParams().set('filter[joint_account?][$eq]', 'true'),
      )
      .pipe(map((response) => this.transformEnrollmentsResponse(response)));
  }

  private transformEnrollmentsResponse(
    loyaltyProgramResponse: EnrollmentResponse,
  ): Enrollment[] {
    return loyaltyProgramResponse.data.map(this.transformEnrollmentModel);
  }

  private transformEnrollmentModel(
    enrollmentModel: EnrollmentModel,
  ): Enrollment {
    const { id, attributes } = enrollmentModel;

    return {
      id,
      ...attributes,
    };
  }
}
